/*
  This is a template for creating a Component class.

  Instructions: copy and paste this file into your newly created react component index.js. Then
  change the appropriate names and add your html render
    The base class for all components should be BaseClass (as indicated in this file)
    The base class insures that all call back handlers with "handle" in the name are bound
    to "this". This insures that "this" is defined as "this" for the containing class
*/

import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import CloseButton from '../Buttons/CloseButton';
import Circle from '../graphics/Circle';
import animator from '../../helpers/animator';
import styles from '../../assets/styles/globals.scss';

import '../PopupView/PopupView.scss';
import './WizardView.scss';

// Change WizardView to the appropriate name
class WizardView extends BaseComponent {

  constructor(props) {
    super(props);
    this.handleWidth = 100;
    this.state = { height: '0px', width: '0px', movedByMouse: false, mouseX: 0, mouseY: 0, currentPage: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);  
    this.wizardId = this.props.wizardId;
    this.animator = new animator();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    if (this.props.wizard.handleOwnerDisplayPage) {
      this.setState({ currentPageDisplay: this.props.wizard.handleOwnerDisplayPage(this.state.currentPage) });
    }
    else {
      this.setState({ currentPageDisplay: this.props.wizard.pages[this.state.currentPage] });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ viewWidth: window.innerWidth, viewHeight: window.innerHeight });
  }

  handleCancelClick(e) {
    if (e) {
      e.stopPropagation();
    }  
    const _this = this;    
    let { handleOwnerCancel } = _this.props.wizard;
    const ani = _this.animator.createPropertyAnimation('wizard-view-' + _this.props.wizard.popupId, 500, { opacity: { startVal: 1, endVal: 0 } });
    this.animator.addAnimation(ani);
    const animator = this.animator;
    if (handleOwnerCancel != undefined) {
      handleOwnerCancel(this.props.wizard.wizardId, animator);
    }
    else{
      animator.processAnimationQueue();
    }
  }

  handleDoneClick(e) {
    if (e) {
      e.stopPropagation();
    }
    const { handleValidation } = this.props.wizard;
    if(handleValidation){
      let validated = handleValidation(this.props.wizard.id); 
      if(validated){
        this.handleOwnerDoneAnimation();
      }
    }
    else {
      this.handleOwnerDoneAnimation();
    }
  }

  handleOwnerDoneAnimation(){
    const ani = this.animator.createPropertyAnimation('wizard-view-' + this.props.wizard.popupId, 500, { opacity: { startVal: 1, endVal: 0 } });
    this.animator.addAnimation(ani);
    this.animator.processAnimationQueue(() => {
      let { handleOwnerDone } = this.props.wizard;
      if (handleOwnerDone != undefined) {
        handleOwnerDone(this.props.wizard.id);
      }
    });
  }

  handleNextClick(e){
    e.stopPropagation();
    if (this.props.wizard.handleOwnerDisplayPage) {
      this.setState({ currentPageDisplay: this.props.wizard.handleOwnerDisplayPage(++this.state.currentPage) });
    }
    else {
      this.setState({ currentPageDisplay: this.props.wizard.pages[++this.state.currentPage] });
    }  
  }

  handleBackClick(e){
    e.stopPropagation();
    if (this.props.wizard.handleOwnerDisplayPage) {
      this.setState({ currentPageDisplay: this.props.wizard.handleOwnerDisplayPage(--this.state.currentPage) });
    }
    else {
      this.setState({ currentPageDisplay: this.props.wizard.pages[--this.state.currentPage] });
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      if (this.state.currentPage == this.props.wizard.pages.length - 1) {
        this.handleDoneClick();
      }
      else {
        this.handleNextClick();
      }
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleCancelClick();
    }
  }

  handleMouseMove(e){
    if (this.mouseDown){
      let deltaX = e.clientX - this.startX;
      let deltaY = e.clientY - this.startY;
      this.lastLeft = this.left + deltaX;
      this.lastTop = this.top + deltaY;
      this.setState({ movedByMouse: true, mouseX: this.lastLeft,
        mouseY: this.lastTop }); 
    }
  }

  handleMouseDown(e) {
    let inCaption = false;
    if (e.target.className == 'caption') {
      inCaption = true;
    }
    else {
      let parent = e.target.parentElement;
      while (parent) {
        if (parent.className == 'caption') {
          inCaption = true;
          break;
        }
        parent = parent.parentElement;
      }
    }
    if (inCaption || e.target.className == 'popup-contents') {
      this.mouseDown = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.setState({ movedByMouse: true, mouseX: this.left, mouseY: this.top });
    }  
  }

  handleMouseUp(e){
    this.mouseDown = false;
    let newState = {};
    if (this.lastLeft < 0){
      this.lastLeft = newState.mouseX = 0;
    }
    if (this.lastTop < 0){
      this.lastTop = newState.mouseY = 0;
    }
    if(this.lastLeft + this.width > this.state.viewWidth){
      this.lastLeft = newState.mouseX = this.state.viewWidth - this.width;
    }
    if (this.lastTop + this.height > this.state.viewHeight){
      this.lastTop = newState.mouseY = this.state.viewHeight - this.height;
    }
    this.left = this.lastLeft;
    this.top = this.lastTop;
    this.setState(newState);
  }

  handleThrowAwayClick(e){
    e.stopPropagation();
  }

  animateMe() {
    if (!this.animating) {
      this.animating = true;
      const _this = this;
      setTimeout(() => {
        const ani = _this.animator.createPropertyAnimation('wizard-view-' + _this.props.wizard.popupId, 500, { opacity: { startVal: 0, endVal: 1 } });
        _this.animator.addAnimation(ani);
        _this.animator.processAnimationQueue(() => {
          _this.animating = false;
          _this.animated = true;
        });
      }, 10);
    }
  }

  render() {
    let { left, top, width, height, captionIcon, iconIsWide, pages, captionPhoto, oneButton, backButtonText, nextButtonText } = 
      this.props.wizard;

    if (pages == null){
      pages = [];
      pages.push(<div>THERE SHOULD BE SOMETHING TO DISPLAY HERE</div>);
    }

    const captionHeight = captionPhoto ? 99 : (pages.length == 1 ? 72 : 80);
    const captionBottom = pages.length == 1 ? 5 : 9;
    this.height = height + captionHeight + captionBottom + 50;

    let buttonLeft = left + width + 10;
    let style = {};

    if (this.state.movedByMouse){
      left = this.state.mouseX;
      top = this.state.mouseY;
    }
  
    else{
      if (left == undefined){
        left = this.state.viewWidth / 2 - (width != undefined ? 
          width / 2 : this.state.viewWidth / 4);
      }
      this.left = left;

      if (top == undefined){
        top = Math.max(20, this.state.viewHeight / 2 - (this.height != undefined ? 
          this.height / 2 : this.state.viewHeight / 4));
      }
      this.top = top;
    }
    style.left = left + 'px';
    style.top = top + 'px';

    if (width == undefined){
      width = this.state.viewWidth / 4;
    }
    buttonLeft = this.width = width;
    buttonLeft += 4 + left;
    style.width = width + 'px';

    if (height == undefined){
      this.height = this.state.viewHeight / 4;
    }
    style.height = this.height;

    let classNames = 'popup-view';

    let buttonText = 'CONTINUE';
    let clickHandler = this.handleNextClick;
    let buttonStyle = {};
    if(oneButton) {
      buttonStyle = { width: '100%' };
      buttonText = nextButtonText ? nextButtonText : 'SAVE';
      clickHandler = this.handleDoneClick;
    }
    else if (pages.length == 1) {
      clickHandler = this.handleDoneClick;
      buttonText = nextButtonText ? nextButtonText : 'SAVE';
    }
    else if (this.state.currentPage == pages.length - 1){
      clickHandler = this.handleDoneClick;
      buttonText = nextButtonText ? nextButtonText : 'DONE';
    }

    let nextDoneButton;

    if (this.props.readyForUpdate == null || this.props.readyForUpdate == undefined) {
      nextDoneButton = <div className="wizard-next-button wizard-button" onClick={clickHandler} style={buttonStyle}>{buttonText}</div>;
    } else if (this.props.readyForUpdate == false) {
      buttonStyle['background-color'] = styles.gray;
      buttonStyle.cursor = 'auto';
      nextDoneButton = <div className="wizard-next-button wizard-button" style={buttonStyle}>{buttonText}</div>;
    } else if (this.props.readyForUpdate == true) {
      nextDoneButton = <div className="wizard-next-button wizard-button" onClick={clickHandler} style={buttonStyle}>{buttonText}</div>;
    }

    let backButton = null;
    if (oneButton) {
      backButton = null;
    }
    else if (this.state.currentPage > 0){
      backButton = <div className="wizard-back-button wizard-button" onClick={this.handleBackClick}>BACK</div>;
    }
    else if (pages.length == 1 || this.state.currentPage == 0) {
      backButton = <div className="wizard-back-button wizard-button" onClick={this.handleCancelClick}>{backButtonText ? backButtonText : 'CANCEL'}</div>;
    }

    let indicatorWidth = 0;
    const stepIndicators = pages.length > 1 ? pages.map((page, index) => {
      indicatorWidth += 14;
      if (index == this.state.currentPage){
        return (
          <Circle key={index} position="block"
            fillColor="#DEDEDE" borderColor="#ffffff" width={7} height={7} />
        );
      }
      else {
        return (
          <Circle key={index} position="block"
            fillColor="#CD030A" borderColor="#ffffff" width={7} height={7} />
        );
      }
    }) : null;

    const stepsWidth = { width: indicatorWidth };
    const stepsPosition = Math.round((width / 2) - (indicatorWidth / 2));
    const stepsStyle = { width: indicatorWidth, left: stepsPosition };

    const caption = this.props.wizard.caption;    
    const step = this.state.currentPageDisplay ? this.state.currentPageDisplay.caption : '';
    let contents = this.state.currentPageDisplay ? this.state.currentPageDisplay.contents : <div />;

    // did the page actually change?
    if (this.state.currentPageDisplay &&
        this.props.wizard.pages[this.state.currentPage].contents != this.state.currentPageDisplay.contents) {
      this.state.currentPageDisplay = this.props.wizard.pages[this.state.currentPage];
      contents = this.state.currentPageDisplay.contents;
    }  
    let captionCircle = null;
    let icon = null;
    let popupStyle = {};
    if (captionIcon) {
      icon = <img className="caption-icon" src={captionIcon} alt="icon"/>;
    }
    else if (captionPhoto) {
      popupStyle.top = 154;
      captionCircle = (
        <div className="caption-circle">
          <img className={'caption-photo ' + (iconIsWide ? 'wide' : '')} src={captionPhoto} alt="Header"/>
        </div>
      );
    }

    const outerClasses = 'outer-popup tinted-background';
    let outerStyle = {};
    if (!this.animated) {
      outerStyle.opacity = 0;
    }
    else {
      outerStyle.opacity = 1;
    }
    if (!this.animated) {
      this.animateMe();
    }

    const innerPopup = 
      <div className={classNames} style={style} onKeyDown={this.handleKeyDown}>
        <div className="caption" style={{ height: captionHeight + 'px' }} >
          <div className="caption-container" style={{ bottom: captionBottom + 'px' }}>
            <div className="caption-text">{icon}{caption}</div>
            <div className="caption-header">{step}</div>
          </div>
          { captionCircle }
        </div>
        <div className={'popup-contents ' + (this.props.wizard.short ? 'short' : '')} style={popupStyle}>
          {contents}
        </div>
        <div className="wizard-footer">
          {backButton}
          <div className="step-indicators" style={stepsStyle}>
            <div className="steps" style={stepsWidth}>
              {stepIndicators}
            </div>  
          </div>
          {nextDoneButton}
        </div>
      </div>;

    let mouseMove = null;
    let mouseDown = null;
    let mouseUp = null;
    mouseMove = this.handleMouseMove;
    mouseDown = this.handleMouseDown;
    mouseUp = this.handleMouseUp;

    return (
        // Replace with the appropriate HTML
        <div id={'wizard-view-' + this.props.wizard.popupId} className={outerClasses} style={outerStyle} 
        onMouseMove={mouseMove}
        onMouseUp={mouseUp}
        onMouseDown={mouseDown}
        onMouseLeave={mouseUp}>?
          <CloseButton left={buttonLeft} top={top} width={20} height={20}
            fillColor="#ffffff" borderColor="#ffffff" hasShadow={false}
            handleClick={this.handleCancelClick} />
          {innerPopup}
        </div>
      );
  }
}

export default (WizardView);



// WEBPACK FOOTER //
// ./src/components/WizardView/index.js